<template>

  <ModalContainer queryParam="view" ref="modal" size="xl">

    <h3 class="text-center">Visualizar información del Doctor</h3>

    <b-row>
      <b-col md="6">
        <b-card class="col-12">
          
          <h5>Información del doctor</h5>

          <b-row v-if="itemDoctor">
            <div class="col-md-12">
              <strong><i class="fas fa-user mr-1"/></strong>
              <span id="v-name">{{ itemDoctor.nombre || '' }}</span>
            </div>

            <div class="col-md-12">
              <strong>
                <i class="fas fa-birthday-cake mr-1"/></strong>
              <span id="v-name">{{ itemDoctor.fechaNacimiento || '' }}</span>
            </div>

            <div class="col-md-12">
              <strong><i class="fas fa-id-card mr-1"/></strong>
              <span id="v-name">{{ itemDoctor.identificacion || '' }}</span>
            </div>

            <div class="col-md-12">
              <strong><i class="fas fa-calendar-alt mr-1"/></strong>
              <span id="v-name">{{ itemDoctor.fechainiciodoctor || '' }}</span>
            </div>

            <div class="col-md-12">
              <strong><i class="fas fa-envelope mr-1"/></strong>
              <span id="v-name">{{ itemDoctor.email || '' }}</span>
            </div>

            <div class="col-md-12">
              <strong><i class="fas fa-certificate mr-1"/></strong>
              <span id="v-name">{{ itemDoctor.numeroregistrosenescyt || '' }}</span>
            </div>

            <div class="col-md-12">
              <strong><i class="fas fa-stethoscope mr-1"/></strong>
              <span id="v-name">{{ itemDoctor.especialidad || '' }}</span>
            </div>

          </b-row>
        </b-card>

        <b-card class="col-12 mt-2">
          <h5>Horario de atención</h5>

          <div v-if="formattedHorarios.length">
            <b-table
              :items="formattedHorarios"
              :fields="horarioFields"
              small
              bordered
              responsive="sm"
              class="mb-0"
            />
          </div>
          <div v-else>
            <span>No se ha configurado un horario para este doctor.</span>
          </div>
        </b-card>
      </b-col>

      <b-col md="6">
        <h5 class="text-center">Documentos</h5>
          
        <b-card class="col-12" style="border: 1px solid #c9c9c9">

          <div class="row d-flex align-items-center my-2">
            <h6 class="col-4">Titulo</h6>

            <b-link
              v-if="urlTitulo" 
              class="text-primary col-4"
              @click="onViewFile(urlTitulo)"
              :disabled="!urlTitulo"
            >
              <span>Ver Archivo </span>
            </b-link>
            <span v-if="!urlTitulo" class="col-4">No hay archivo</span>
          </div>

          <hr>

          <div class="row d-flex align-items-center my-2">
            <h6 class="col-4">Firma</h6>

            <b-link 
              v-if="urlFirma"
              class="text-primary col-4"
              @click="onViewFile(urlFirma)"
            >
              <span>Ver Archivo</span>
            </b-link>

            <span v-if="!urlFirma" class="col-4">No hay archivo</span>

            <div v-if="urlFirma" style="width: 100px">
              <img :src="`${rutas.axios}/file/show${urlFirma}`"  width="100">
            </div>

          </div>

          <hr>

          <div class="row d-flex align-items-center my-2">
            <h6 class="col-4">Firma y Sello</h6>

            <b-link
              v-if="urlSello"
              class="text-primary col-4"
              @click="onViewFile(urlSello)" 
            >
              <span>Ver Archivo </span>
            </b-link>
            <span v-if="!urlSello" class="col-4">No hay archivo</span>

            <div v-if="urlSello" style="width: 100px">
              <img :src="`${rutas.axios}/file/show${urlSello}`"  width="100">
            </div>
          </div>

        </b-card>
      </b-col>
    </b-row>

      
    <ModalViewFile
      v-if="fileToView"
      :urlFile="fileToView"
      v-model="isModalFileVisible"
    />

  </ModalContainer>
</template>


<script>
import rutas from '@/assets/utils/rutas.json';
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTag } from '@fortawesome/free-solid-svg-icons/';
import { BootstrapVue } from 'bootstrap-vue';
import axios from 'axios';
import { ModalViewFile, ModalContainer } from '@/shared/components';
import { doctoresService } from '../../services';

library.add(faTag);

const DAY_LABELS = {
  1: 'Lunes',
  2: 'Martes',
  3: 'Miércoles',
  4: 'Jueves',
  5: 'Viernes',
  6: 'Sábado',
};

const parseDayValue = (value) => {
  if (typeof value === 'number') return value;
  if (!value && value !== 0) return null;
  const match = String(value).match(/\d+/);
  return match ? Number(match[0]) : null;
};

export default {

  components: {
    ...BootstrapVue.components,
    ModalViewFile,
    ModalContainer,
  },

  data() {
    return {
      fileToView: null,
      isModalFileVisible: false,
      itemDoctor: null,
      horarios: [],
      rutas,
    };
  },

  created() {
    this.getData();
    this.setToken();
  },

  methods: {
    onViewFile(urlF) {
      this.fileToView = urlF;
      this.isModalFileVisible = true;
    },

    comprobarPermisos() {
      if (localStorage.getItem('permisos').indexOf('adm_ver_doctor') === -1) {
        this.$router.push({ name: 'not-permitted' });
      }
    },

    setToken() {
      const user = JSON.parse(localStorage.getItem('usuario'));
      axios.defaults.headers.common.Authorization = `JWT ${user.token}`;
    },

    formatTime(time) {
      if (!time) return '';
      return time.toString().slice(0, 5);
    },

    async getData() {
      const tokenDoctor = this.$route.query.view;
      const responseDoctor = await doctoresService.getAll({ tokenDoctor });

      if (!responseDoctor || !responseDoctor.doctores.length) return;

      const doctor = responseDoctor.doctores[0];
      const nombre = `${doctor.idPersona.primerApellido} ${doctor.idPersona.primerNombre}`;

      this.itemDoctor = {
        nombre,
        identificacion: doctor.idPersona.identificacion,
        fechaNacimiento: doctor.idPersona.fechaNacimiento,
        especialidad: doctor.especialidad.descripcion,
        numeroregistrosenescyt: doctor.numeroregistrosenescyt,
        urlFirma: doctor.urlP12FirmaElectronica,
        urlTitulo: doctor.urlTituloSenescyt,
        urlFirmaSello: doctor.urlFirmaSello,
        fechainiciodoctor: doctor.fechainiciodoctor,
        email: doctor.idPersona.correo,
      };

      this.horarios = doctor.horarios || [];
    },
  },

  computed: {
    urlFirma() {
      return this.itemDoctor?.urlFirma;
    },

    urlTitulo() {
      return this.itemDoctor?.urlTitulo;
    },

    urlSello() {
      return this.itemDoctor?.urlFirmaSello;
    },

    formattedHorarios() {
      if (!this.horarios || !this.horarios.length) return [];

      return this.horarios.map((item) => {
        const dayValue = parseDayValue(item.dia);
        return {
          dia: DAY_LABELS[dayValue] || item.dia,
        intervalo: `${this.formatTime(item.horaInicio)} - ${this.formatTime(item.horaFin)}`,
          turno: `Cada ${item.duracionTurno} minutos`,
        };
      });
    },

    horarioFields() {
      return [
        { key: 'dia', label: 'Día' },
        { key: 'intervalo', label: 'Horario' },
        { key: 'turno', label: 'Turnos' },
      ];
    },
  },

  watch: {
    '$route.query.view': {
      immediate: true,
      handler() {
        this.getData();
      },
    },
  },

};
</script>
